<template>
  <sidebar
    :addTitle="$t('CashFlow.Region.AddNew')"
    :editTitle="$t('CashFlow.Region.Edit')"
    :isSidebarActive="isSidebarActive"
    :data="data"
    @onNewData="newData"
    @onEditData="editData"
    @closeSidebar="closeSidebar">
    <ValidationObserver ref="observer">
      <div class="p-6">
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('CashFlow.Region.Name')" rules="required" v-slot="{ errors }">
              <validated-input
                :label="$t('CashFlow.Region.Name')"
                v-model="regionName"
              ></validated-input>
               <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('CashFlow.Region.IncomeTax')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('CashFlow.Region.IncomeTax')"
                v-model="regionIncomeTax"
              ></validated-input>
               <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col vs-w="12">
            <ValidationProvider :name="$t('CashFlow.Region.MiningTax')" rules="required|decimal:2|between:0,100" v-slot="{ errors }">
              <validated-input
                :label="$t('CashFlow.Region.MiningTax')"
                v-model="regionMiningTax"
              ></validated-input>
               <validation-message>{{ errors[0] }}</validation-message>
            </ValidationProvider>
          </vs-col>
        </vs-row>
      </div>
    </ValidationObserver>
    <template v-slot:footer>
      <vs-button class="mr-6" @click="submitData">{{ $t('Submit') }}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{ $t('Cancel') }}</vs-button>
    </template>
  </sidebar>
</template>

<script>
import {
  ValidatedInput,
  ValidationMessage,
  Sidebar
} from "./../../../../shared/components";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ValidatedInput,
    ValidationMessage,
    Sidebar
  },
  data() {
    return {
      regionId: 0,
      regionName: "",
      regionIncomeTax: 0,
      regionMiningTax: 0
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      }
    }
  },
  methods: {
    newData() {
      this.initValues();
      this.$refs.observer.reset();
    },
    editData() {
      const {id, name, incomeTax, miningTax} = JSON.parse(JSON.stringify(this.data));
      this.regionId = id;
      this.regionName = name;
      this.regionIncomeTax = incomeTax;
      this.regionMiningTax = miningTax;
      this.$refs.observer.reset();
    },
    closeSidebar() {
      this.$emit("closeSidebar");
    },
    initValues() {
      if (this.data.id) return;
      this.regionId = 0;
      this.regionName = "";
      this.regionIncomeTax = 0;
      this.regionMiningTax = 0;
    },
    submitData() {
      this.$refs.observer.validate().then(result => {
        if (result) {
          const obj = {
            id: this.regionId,
            name: this.regionName,
            incomeTax: this.regionIncomeTax,
            miningTax : this.regionMiningTax
          };

          const exists = this.$store.getters['cashflow/regionAlreadyExists'](obj.name, obj.id);
          if (exists) {
            this.$vs.notify({
              color: "danger",
              title: this.$t("SavingError"),
              text: this.$t("CashFlow.Region.AlreadyExists")
            });
            return;
          }

          this.$vs.loading();

          if (this.regionId !== null && this.regionId > 0) {
            this.$store.dispatch("cashflow/updateRegion", obj).then(() => {
              this.$emit("onRegionUpdated", obj);
            }).finally(() => {
              this.$vs.loading.close();
            });
          } else {
            this.$store.dispatch("cashflow/addRegion", obj).then(() => {
              this.$emit("onRegionInserted", obj);
            }).finally(() => {
              this.$vs.loading.close();
            });
          }
        }
      });
    }
  }
};
</script>
